import script from "./sample.vue?vue&type=script&setup=true&lang=ts"
export * from "./sample.vue?vue&type=script&setup=true&lang=ts"

import "./sample.vue?vue&type=style&index=0&id=1b070672&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b070672"]])

export default __exports__